<div class="ammunition">
  <div class="translucent">
    <h4 class="section-header">Ammunition</h4>
    <ul class="content">
      <li *ngFor="let ammo of ammunition">
        {{ ammo }}
      </li>
    </ul>
  </div>
</div>
